import { Link } from "@/lib/router-compat";
import { ArrowRight } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { defaultBlogPostImage } from "@/pages/Blog";

export const UpdatesSection = () => {
  const { data: posts } = useQuery({
    queryKey: ["updates-posts"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("blog_posts")
        .select("*")
        .eq("published", true)
        .or("scheduled_at.is.null,scheduled_at.lte.now()")
        .order("created_at", { ascending: false })
        .limit(3);
      if (error) throw error;
      return data;
    },
  });

  const articles = posts ?? [];
  if (articles.length === 0) return null;

  return (
    <section className="relative py-20 bg-[#1a1a1a] overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4">
            TIPS & INSIGHTS
          </h2>
          <p className="text-white/60 text-lg">
            Expert advice for homeowners on roofing, siding, and exterior maintenance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {articles.map((post) => (
            <Link key={post.slug} to={`/blog/${post.slug}`} className="group block">
              <div className="rounded-xl overflow-hidden mb-4 bg-muted">
                <img
                  src={post.image_url || defaultBlogPostImage}
                  alt={post.title}
                  className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="flex items-center gap-3 mb-3">
                <span className="text-xs font-medium text-secondary border border-secondary/30 rounded-full px-3 py-1">
                  {post.category}
                </span>
                <span className="text-white/50 text-sm">{post.read_time}</span>
              </div>
              <h3 className="text-xl font-heading font-bold text-white mb-2 group-hover:text-secondary transition-colors line-clamp-2">
                {post.title}
              </h3>
              <p className="text-white/60 text-base leading-relaxed line-clamp-2 mb-4">
                {post.excerpt}
              </p>
              <span className="inline-flex items-center gap-1 text-secondary text-sm font-medium font-subheading group-hover:gap-2 transition-all">
                Read more <ArrowRight className="w-4 h-4" />
              </span>
            </Link>
          ))}
        </div>

        <div className="flex justify-center">
          <Link to="/blog">
            <Button variant="outline" className="bg-transparent font-semibold font-subheading border-white/30 text-white hover:bg-white/10 hover:text-white">
              All Articles <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
